var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"login-title h50"},[_c('span'),_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('span',{staticClass:"logo-title"},[_vm._v("医生工作站")])])
}]

export { render, staticRenderFns }